import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  props: {
    title: String,
    desc: String,
  },
  components: {
    popper: Popper,
  },
};
